export { VIcon } from './VIcon'
export { VComponentIcon, VSvgIcon, VLigatureIcon, VClassIcon } from '@/composables/icons'
